import React, { useEffect, useState } from 'react';
import { gql, useQuery } from "@apollo/client";

const GET_PEDIDOS = gql`
  query getPedidos {
    getPedidos {
      _id
      fecha
      productos
    }
  }
`;

const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

function ProductosPorDia() {
  const { loading, error, data } = useQuery(GET_PEDIDOS);
  const [ventasPorFecha, setVentasPorFecha] = useState({});
  const [filtro, setFiltro] = useState('');
  const [totalSemana, setTotalSemana] = useState({ cantidad: 0, total: 0 });

  const obtenerClaveFecha = (fechaISO) => {
    const fecha = new Date(fechaISO);
    fecha.setHours(fecha.getHours() - 5);
    return `${fecha.getFullYear()}-${(fecha.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${fecha.getDate().toString().padStart(2, '0')}`;
  };

  const obtenerTextoFecha = (fechaISO) => {
    const fecha = new Date(fechaISO);
    fecha.setHours(fecha.getHours() - 5);
    const diaSemana = diasSemana[fecha.getDay()];
    const dd = fecha.getDate().toString().padStart(2, '0');
    const mm = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const yyyy = fecha.getFullYear();
    return `${diaSemana} - ${dd}/${mm}/${yyyy}`;
  };

  const esDentroDeUltimos7Dias = (fechaISO) => {
    const hoy = new Date();
    const fecha = new Date(fechaISO);
    const diferencia = hoy - fecha;
    return diferencia <= 7 * 24 * 60 * 60 * 1000;
  };

  useEffect(() => {
    if (data?.getPedidos) {
      const resumen = {};

      data.getPedidos.forEach(pedido => {
        if (!esDentroDeUltimos7Dias(pedido.fecha)) return;

        const claveFecha = obtenerClaveFecha(pedido.fecha);
        const textoFecha = obtenerTextoFecha(pedido.fecha);
        const productos = JSON.parse(pedido.productos || '[]');

        if (!resumen[claveFecha]) {
          resumen[claveFecha] = {
            textoFecha,
            productos: {}
          };
        }

        productos.forEach(producto => {
          const nombre = producto.nombre.toLowerCase();
          let total = 0;

          if (producto.codigo === '1') {
            // precio por kilo → precio por gramo
            const precioPorGramo = producto.precio / 1000;
            total = precioPorGramo * producto.cantidad;
          } else {
            total = producto.precio * producto.cantidad;
          }

          if (!resumen[claveFecha].productos[nombre]) {
            resumen[claveFecha].productos[nombre] = { cantidad: 0, total: 0 };
          }

          resumen[claveFecha].productos[nombre].cantidad += producto.cantidad;
          resumen[claveFecha].productos[nombre].total += total;
        });
      });

      setVentasPorFecha(resumen);
    }
  }, [data]);

  // Recalcular total semanal SOLO del producto filtrado
  useEffect(() => {
    const productoBuscado = filtro.trim().toLowerCase();
    let sumaCantidad = 0;
    let sumaTotal = 0;

    if (productoBuscado === '') {
      setTotalSemana({ cantidad: 0, total: 0 });
      return;
    }

    Object.values(ventasPorFecha).forEach(({ productos }) => {
      Object.entries(productos).forEach(([nombre, datos]) => {
        if (nombre.includes(productoBuscado)) {
          sumaCantidad += datos.cantidad;
          sumaTotal += datos.total;
        }
      });
    });

    setTotalSemana({ cantidad: sumaCantidad, total: sumaTotal });
  }, [ventasPorFecha, filtro]);

  if (loading) return <p>Cargando ventas...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const productoBuscado = filtro.trim().toLowerCase();
  const fechasOrdenadas = Object.keys(ventasPorFecha).sort();

  return (
    <div>
      <h2>Ventas de los últimos 7 días (ordenadas por fecha)</h2>

      <input
        type="text"
        placeholder="Filtrar por nombre de producto..."
        value={filtro}
        onChange={(e) => setFiltro(e.target.value)}
        style={{ marginBottom: '20px', padding: '8px', width: '300px' }}
      />

      {fechasOrdenadas.map(fechaKey => {
        const { textoFecha, productos } = ventasPorFecha[fechaKey];

        const productosFiltrados = Object.entries(productos)
          .filter(([nombre]) =>
            productoBuscado === '' || nombre.includes(productoBuscado)
          );

        if (productosFiltrados.length === 0) return null;

        return (
          <div key={fechaKey} style={{ marginBottom: '20px' }}>
            <h3>{textoFecha}</h3>
            <ul>
              {productosFiltrados.map(([nombre, datos]) => (
                <li key={nombre}>
                  <strong>{nombre}</strong>: Cantidad: {datos.cantidad}, Total: ${datos.total.toLocaleString()}
                </li>
              ))}
            </ul>
          </div>
        );
      })}

      {productoBuscado !== '' && (
        <>
          <hr />
          <h3>Resumen semanal del producto filtrado</h3>
          <p><strong>Cantidad total vendida:</strong> {totalSemana.cantidad}</p>
          <p><strong>Total en dinero:</strong> ${totalSemana.total.toLocaleString()}</p>
        </>
      )}
    </div>
  );
}

export default ProductosPorDia;